var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-shopConfirmListItem"},[_c('dt',{staticClass:"p-shopConfirmListItem__organization",domProps:{"textContent":_vm._s(_vm.organizationName)}}),_c('dd',{staticClass:"p-shopConfirmListItem__date",domProps:{"textContent":_vm._s(_vm.$options.filters.dayjsFormat(_vm.data.confirmedAt))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }